import { apiSlice } from "../../app/api/apiSlice";

export const publicQuickPricerApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		publicQuickPricer: builder.mutation({
			query: (data) => ({
				url: "/api/v1/loan/public/quick_pricer/",
				method: "POST",
				body: data,
			}),
		}),
	}),
});

export const { usePublicQuickPricerMutation } = publicQuickPricerApiSlice;
